export class ShibFeLoginController {
  constructor() {
    this.processLogin();
  }

  protected checkCookie(cookieName) {
    let cname = cookieName + '=';
    let cookieDecode = decodeURIComponent(document.cookie);
    let cookieSplit = cookieDecode.split(';');
    for (let i = 0; i < cookieSplit.length; i++) {
      let cookie = cookieSplit[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(cname) === 0) {
        return true;
      }
    }
    return false;
  }

  protected processLogin() {
    let loginLinks = document.getElementsByClassName('shibfelogin');
    if (loginLinks.length > 0) {
      if (this.checkCookie('shibfeauth_typo_user')) {
        let eIDurl = document.location.protocol + '//' + document.location.hostname +
            '/?eID=shibFeLoginCheck&no_cache=1';
        let checkFeAuth = new XMLHttpRequest();

        checkFeAuth.open('GET', eIDurl, true);
        checkFeAuth.onload = function () {
          if (checkFeAuth.status >= 200 && checkFeAuth.status < 400) {
            let responseData = checkFeAuth.responseText;
            if (responseData === 'true') {
              for (let i = 0, j = loginLinks.length; i < j; i++) {
                  let loginLink = loginLinks!.item(i)!.children[0];
                  let logoutUrl = loginLink!.getAttribute('data-logouturl');
                  let linkLabel = loginLink!.getAttribute('data-logoutlabel');
                  if (loginLink && logoutUrl && linkLabel) {
                      loginLink!.setAttribute('href', logoutUrl);
                      loginLink!.innerHTML = linkLabel;
                  }
              }
            }
          }
        };

        checkFeAuth.send();
      }
    }
  }
}
